import { PositionsService } from '@/services/positions.service'

export default {
  namespaced: true,
  state: {
    availablePositions: null,
  },

  getters: {
    availablePositions(state) {
      return state.availablePositions
    },
  },

  /**
   * Request user positions array
   *
   * @returns {Array} available positions list
   */
  actions: {
    getPositions({ commit }) {
      return PositionsService.getPositionsList()
        .then((response) => commit('SET_POSITIONS', response.data.data))
        .catch((error) =>
          commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
        )
    },
  },

  mutations: {
    SET_POSITIONS(state, positions) {
      state.availablePositions = positions
    },
  },
}
